import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";


// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Roles
import RolesList from "pages/Roles/RolesList";
import AddRole from "pages/Roles/AddRole";
import EditRole from "pages/Roles/EditRole";
import RolesPermissions from "pages/Roles/RolesPermissions";

// Users
import UsersList from "pages/Users/UsersList";
import AddUser from "pages/Users/AddUser";
import EditUser from "pages/Users/EditUser";
import RemoveUser from "pages/Users/RemoveUser";

// Addresses
import AddressList from "pages/Addresses/AddressList";
import AddAddress from "pages/Addresses/AddAddress";
import EditAddress from "pages/Addresses/EditAddress";
import RemoveAddress from "pages/Addresses/RemoveAddress";

// Countries
import CountryList from "pages/Countries/CountryList";
import AddCountry from "pages/Countries/AddCountry";
import EditCountry from "pages/Countries/EditCountry";
import RemoveCountry from "pages/Countries/RemoveCountry";

// Cities
import CityList from "pages/Cities/CityList";
import AddCity from "pages/Cities/AddCity";
import EditCity from "pages/Cities/EditCity";
import RemoveCity from "pages/Cities/RemoveCity";

// Districts
import DistrictList from "pages/Districts/DistrictList";
import AddDistrict from "pages/Districts/AddDistrict";
import EditDistrict from "pages/Districts/EditDistrict";
import RemoveDistrict from "pages/Districts/RemoveDistrict";

// SubDistricts
import SubDistrictList from "pages/SubDistricts/SubDistrictList";
import AddSubDistrict from "pages/SubDistricts/AddSubDistrict";
import EditSubDistrict from "pages/SubDistricts/EditSubDistrict";
import RemoveSubDistrict from "pages/SubDistricts/RemoveSubDistrict";

// Languages
import LanguageList from "pages/Languages/LanguageList";
import AddLanguage from "pages/Languages/AddLanguage";
import EditLanguage from "pages/Languages/EditLanguage";
import RemoveLanguage from "pages/Languages/RemoveLanguage";

// Languages
import ReasonList from "pages/Reasons/ReasonList";
import AddReason from "pages/Reasons/AddReason";
import EditReason from "pages/Reasons/EditReason";
import RemoveReason from "pages/Reasons/RemoveReason";

//Tickets
import TicketsList from "pages/Tickets/TicketsList";
import TicketDetails from "pages/Tickets/TicketDetails";

// Application Setup
import ApplicationSetup from "pages/Application/setup";

// Express Delivery Settings
import ExpressDeliverySettings from "pages/Express Delivery Settings/settings";

// Terms
import TermsList from "pages/Terms/TermsList";
import AddTerm from "pages/Terms/AddTerm";
import UpdateTerm from "pages/Terms/UpdateTerm";

// Privacy Policy
import PolicyList from "pages/PrivacyPolicy/PolicyList";
import UpdatePolicy from "pages/PrivacyPolicy/UpdatePolicy";
import AddPolicy from "pages/PrivacyPolicy/AddPolicy";

// FAQs
import FaqList from "pages/FAQs/FaqList";
import AddFaq from "pages/FAQs/AddFaq";
import UpdateFaq from "pages/FAQs/UpdateFaq";

//Categories
import CategoryList from "pages/Categories/CategoryList";
import AddCategory from "pages/Categories/AddCategory";
import EditCategory from "pages/Categories/EditCategory";
import RemoveCategory from "pages/Categories/RemoveCategory";

//Banners
import BannersList from "pages/Banners/BannersList";
import AddBanner from "pages/Banners/AddBanner";
import EditBanner from "pages/Banners/EditBanner";
import RemoveBanner from "pages/Banners/RemoveBanner";

//Offers
import OffersList from "pages/Offers/OffersList";
import AddOffer from "pages/Offers/AddOffer";
import EditOffer from "pages/Offers/EditOffer";
import RemoveOffer from "pages/Offers/RemoveOffer";

//Vehicles
import VehicleList from "pages/Vehicles/VehicleList";
import AddVehicle from "pages/Vehicles/AddVehicle";
import EditVehicle from "pages/Vehicles/EditVehicle";
import RemoveVehicle from "pages/Vehicles/RemoveVehicle";
import AddVehicleDocument from "pages/Vehicles/AddVehicleDocument";

//Vehicle Categories
import VehicleCategoriesList from "pages/Vehicles/VehicleCategories/VehiceCategoriesList";
import AddVehicleCategory from "pages/Vehicles/VehicleCategories/AddVehicleCategory";
import EditVehicleCategory from "pages/Vehicles/VehicleCategories/EditVehicleCategory";
import RemoveVehicleCategory from "pages/Vehicles/VehicleCategories/RemoveVehicleCategory";


//Screens
import ModulesList from "pages/Screens/Modules/ModuleList";
import AddModule from "pages/Screens/Modules/AddModule";
import EditModule from "pages/Screens/Modules/AddModule";
import ScreensList from "pages/Screens/ScreensList";
import AddScreen from "pages/Screens/AddScreen";
import EditScreen from "pages/Screens/AddScreen";
import SectionsList from "pages/Screens/Sections/SectionsList";
import AddSection from "pages/Screens/Sections/AddSection";
import EditSection from "pages/Screens/Sections/EditSection";
import RemoveSection from "pages/Screens/Sections/RemoveSection";

//Drivers
import DriversList from "pages/Drivers/DriversList";
import AddDriver from "pages/Drivers/AddDriver";
import AddDriverDocument from "pages/Drivers/AddDriverDocument";
import EditDriver from "pages/Drivers/EditDriver";
import ControlDriver from "pages/Drivers/DriverControl";
import RemoveDriver from "pages/Drivers/RemoveDriver";
import DriverTrReport from "pages/Drivers/DriversTrReport";
//Driver Types
import DriverTypesList from "pages/DriverType/DriverTypeList";
import AddDriverType from "pages/DriverType/AddDriverType";
import EditDriverType from "pages/DriverType/EditDriverType";
import RemoveDriverType from "pages/DriverType/RemoveDriverType";

//Collectors
import CollectorsList from "pages/Collectors/CollectorsList";
import AddCollector from "pages/Collectors/AddCollector";
import TransferDriverBalance from "pages/Collectors/TransferDriverBalance";
import ClearWallet from "pages/Collectors/ClearWallet";
import RemoveCollector from "pages/Collectors/RemoveCollector";

//Partners
import PartnersList from "pages/Partners/PartnersList";
import AddPartner from "pages/Partners/AddPartner";
import EditPartner from "pages/Partners/EditPartner";
import RemovePartner from "pages/Partners/RemovePartner";

//Partners Branch
import PartnersBranchList from "pages/PartnersBranch/PartnersBranchList";
import AddPartnerBranch from "pages/PartnersBranch/AddPartnerBranch";
import EditPartnerBranch from "pages/PartnersBranch/EditPartnerBranch";
import RemovePartnerBranch from "pages/PartnersBranch/RemovePartnerBranch";

//Logs
// import DirectDeliveryLogs from "pages/Logs/DirectDeliveryLogs";
import CollectionHubLogs from "pages/Logs/CollectionHubLogs";
import OrderLogs from "pages/Logs/OrderLogs";
import DriverLogs from "pages/Logs/DriverLogs";
import PartnerLogs from "pages/Logs/PartnerLogs"
import PartnerBranchLogs from "pages/Logs/PartnerBranchLogs"
import SmsLogs from "pages/Logs/SmsLogs"
//CollectionHubs
import CollHubList from "pages/CollectionHubs/CollectionHubsList";
import AddCollHub from "pages/CollectionHubs/AddCollectionHub";
import RemoveCollHub from "pages/CollectionHubs/RemoveCollectionHub";

//Items
import ItemsList from "pages/Items/ItemsList";
import AddItem from "pages/Items/AddItem";
import EditItem from "pages/Items/EditItem";
import RemoveItem from "pages/Items/RemoveItem";

//Services
import ServicesList from "pages/Services/ServicesList";
import AddService from "pages/Services/AddService";
import EditService from "pages/Services/EditService";
import RemoveService from "pages/Services/RemoveService";

//Shipment Types
import ShipmentTypeList from "pages/ShipmentTypes/ShipmentTypeList";
import AddShipmentType from "pages/ShipmentTypes/AddShipmentType";
import EditShipmentType from "pages/ShipmentTypes/EditShipmentType";
import RemoveShipmentType from "pages/ShipmentTypes/RemoveShipmentType";

//Delivery Types
import DeliveryTypeList from "pages/DeliveryTypes/DeliveryTypeList";
import AddDeliveryType from "pages/DeliveryTypes/AddDeliveryType";
import EditDeliveryType from "pages/DeliveryTypes/EditDeliveryType";
import RemoveDeliveryType from "pages/DeliveryTypes/RemoveDeliveryType";

//Tasks
import TaskList from "pages/Tasks/TaskList";
import AddTask from "pages/Tasks/AddTask";
import EditTask from "pages/Tasks/EditTask";
import RemoveTask from "pages/Tasks/RemoveTask";

//Orders
import OrdersList from "pages/Orders/OrdersList";
import AddOrder from "pages/Orders/AddOrder";
import EditOrder   from "pages/Orders/AddOrder";
import RemoveOrder from "pages/Orders/RemoveOrder";
import ModOrder from "pages/Orders/ModOrder";
import OrderDetails from "pages/Orders/OrderDetails";

//Timeslots
import TimeslotList from "pages/TimeSlots/TimeSlotList";
import AddTimeSlot from "pages/TimeSlots/AddTimeSlot";
import EditTimeSlot   from "pages/TimeSlots/AddTimeSlot";
import RemoveTimeSlot from "pages/TimeSlots/RemoveTimeSlot";
import AddTimeSlotException from "pages/TimeSlots/AddTimeSlotException";
import TimeSlotExceptionList from "pages/TimeSlots/TimeSlotExceptionList";
import EditTimeSlotException from "pages/TimeSlots/AddTimeSlotException";
import RemoveTimeSlotException from "pages/TimeSlots/RemoveTimeSlotException";

//Status
import StatusList from "pages/Status/StatusList";
import AddStatus from "pages/Status/AddStatus";
import EditStatus from "pages/Status/EditStatus";
import RemoveStatus from "pages/Status/RemoveStatus";
import PartnersBranchTimeSlotList from "pages/PartnersBranchTimeSlot/PartnersBranchTimeSlotList";
import AddPartnerBranchTimeSlot from "pages/PartnersBranchTimeSlot/AddPartnerBranchTimeSlot";
import EditPartnerBranchTimeSlot from "pages/PartnersBranchTimeSlot/EditPartnerBranchTimeSlot";
import RemovePartnerBranchTimeSlot from "pages/PartnersBranchTimeSlot/RemovePartnerBranchTimeSlot";
// payment methods
import PaymentMethodList from "pages/PaymentMethods/PaymentMethodList";
import AddPaymentMethod from "pages/PaymentMethods/AddPaymentMethod";
import EditPaymentMethod from "pages/PaymentMethods/EditPaymentMethod";
import RemovePaymentMethod from "pages/PaymentMethods/RemovePaymentMethod";
// payment statuses
import PaymentStatusesList from "pages/PaymentStatuses/PaymentStatusesList";
import AddPaymentStatus from "pages/PaymentStatuses/AddPaymentStatus";
import EditPaymentStatus from "pages/PaymentStatuses/EditPaymentStatus";
import RemovePaymentStatus from "pages/PaymentStatuses/RemovePaymentStatus";

// emergency types
import EmergencyTypesList from "pages/EmergencyTypes/EmergencyTypesList";
import AddEmergencyType from "pages/EmergencyTypes/AddEmergencyType";
import EditEmergencyType from "pages/EmergencyTypes/EditEmergencyType";
import RemoveEmergencyType from "pages/EmergencyTypes/RemoveEmergencyType";

// emergency sub types
import EmergencySubTypesList from "pages/EmergencySubTypes/EmergencySubTypesList";
import AddEmergencySubType from "pages/EmergencySubTypes/AddEmergencySubType";
import EditEmergencySubType from "pages/EmergencySubTypes/EditEmergencySubType";
import RemoveEmergencySubType from "pages/EmergencySubTypes/RemoveEmergencySubType";

// driver emergencies
import DriverEmergenciesList from "pages/DriverEmergencies/DriverEmergenciesList";
import EditDriverEmergency from "pages/DriverEmergencies/EditDriverEmergency";
// import RemoveDriverEmergency from "pages/DriverEmergencies/RemoveDriverEmergency";

// articles
import ArticlesList from "pages/Articles/ArticlesList";
import AddArticle from "pages/Articles/AddArticle";
import EditArticle from "pages/Articles/EditArticle";
import RemoveArticle from "pages/Articles/RemoveArticle";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  //profile
  { path: "/profile", component: <UserProfile /> },

  //Roles
  { path: "/roles", component: <RolesList /> },
  { path: "/roles/add/", component: <AddRole /> },
  { path: "/roles/edit/:id", component: <EditRole /> },
  { path: "/roles/permissions", component: <RolesPermissions /> },

  //users
  { path: "/users", component: <UsersList /> },
  { path: "/users/add", component: <AddUser /> },
  { path: "/users/edit/:id", component: <EditUser /> },
  { path: "/users/remove/:id", component: <RemoveUser /> },

  //addresses
  { path: "/address", component: <AddressList /> },
  { path: "/address/add", component: <AddAddress /> },
  { path: "/address/edit/:id", component: <AddAddress /> },
  { path: "/address/remove/:id", component: <RemoveAddress /> },

  //countries
  { path: "/countries", component: <CountryList /> },
  { path: "/countries/add", component: <AddCountry /> },
  { path: "/countries/edit/:id", component: <EditCountry /> },
  { path: "/countries/remove/:id", component: <RemoveCountry /> },

  //cities
  { path: "/cities", component: <CityList /> },
  { path: "/cities/add", component: <AddCity /> },
  { path: "/cities/edit/:id", component: <EditCity /> },
  { path: "/cities/remove/:id", component: <RemoveCity /> },

  //districts
  { path: "/districts", component: <DistrictList /> },
  { path: "/districts/add", component: <AddDistrict /> },
  { path: "/districts/edit/:id", component: <EditDistrict /> },
  { path: "/districts/remove/:id", component: <RemoveDistrict /> },

  //sub-districts
  { path: "/sub-districts", component: <SubDistrictList /> },
  { path: "/sub-districts/add", component: <AddSubDistrict /> },
  { path: "/sub-districts/edit/:id", component: <EditSubDistrict /> },
  { path: "/sub-districts/remove/:id", component: <RemoveSubDistrict /> },

  //delivery types
  { path: "/delivery-types", component: <DeliveryTypeList /> },
  { path: "/delivery-types/add", component: <AddDeliveryType /> },
  { path: "/delivery-types/edit/:id", component: <EditDeliveryType /> },
  { path: "/delivery-types/remove/:id", component: <RemoveDeliveryType /> },

  //tasks
  { path: "/tasks", component: <TaskList /> },
  { path: "/tasks/add", component: <AddTask /> },
  { path: "/tasks/edit/:id", component: <EditTask /> },
  { path: "/tasks/remove/:id", component: <RemoveTask /> },

  //languages
  { path: "/languages", component: <LanguageList /> },
  { path: "/languages/add", component: <AddLanguage /> },
  { path: "/languages/edit/:id", component: <EditLanguage /> },
  { path: "/languages/remove/:id", component: <RemoveLanguage /> },

  //reasons
  { path: "/reasons", component: <ReasonList /> },
  { path: "/reasons/add", component: <AddReason /> },
  { path: "/reasons/edit/:id", component: <EditReason /> },
  { path: "/reasons/remove/:id", component: <RemoveReason /> },

  //setup
  { path: "/application/setup", component: <ApplicationSetup /> },

  //Express Settings
  {
    path: "/express-delivery-settings/settings",
    component: <ExpressDeliverySettings />,
  },

  //Tickets
  { path: "/tickets", component: <TicketsList /> },
  { path: "/tickets/details/:id", component: <TicketDetails /> },

  //Terms
  { path: "/terms", component: <TermsList /> },
  { path: "/terms/add/", component: <AddTerm /> },
  { path: "/terms/update/:id", component: <UpdateTerm /> },

  //Privacy Policy
  { path: "/privacy-policy", component: <PolicyList /> },
  { path: "/policy/add/", component: <AddPolicy /> },
  { path: "/privacy-policy/update/:id", component: <UpdatePolicy /> },

  //FAQs
  { path: "/faqs", component: <FaqList /> },
  { path: "/faqs/add/", component: <AddFaq /> },
  { path: "/faqs/update/:id", component: <UpdateFaq /> },

  //Categories
  { path: "/categories", component: <CategoryList /> },
  { path: "/categories/add", component: <AddCategory /> },
  { path: "/categories/edit/:id", component: <EditCategory /> },
  { path: "/categories/remove/:id", component: <RemoveCategory /> },

  //Banners
  { path: "/banners", component: <BannersList /> },
  { path: "/banners/add", component: <AddBanner /> },
  { path: "/banners/edit/:id", component: <EditBanner /> },
  { path: "/banners/remove/:id", component: <RemoveBanner /> },

  //Offers
  { path: "/offers", component: <OffersList /> },
  { path: "/offers/add", component: <AddOffer /> },
  { path: "/offers/edit/:id", component: <EditOffer /> },
  { path: "/offers/remove/:id", component: <RemoveOffer /> },

  //Vehicles
  { path: "/vehicles", component: <VehicleList /> },
  { path: "/vehicles/add", component: <AddVehicle /> },
  { path: "/vehicles/edit/:id", component: <EditVehicle /> },
  { path: "/vehicles/remove/:id", component: <RemoveVehicle /> },
  { path: "/vehicles/add-document", component: <AddVehicleDocument /> },

  //Vehicle Categories
  { path: "/vehicle-categories", component: <VehicleCategoriesList /> },
  { path: "/vehicle-categories/add", component: <AddVehicleCategory /> },
  { path: "/vehicle-categories/edit/:id", component: <EditVehicleCategory /> },
  {
    path: "/vehicle-categories/remove/:id",
    component: <RemoveVehicleCategory />,
  },

  //Screens
  { path: "/modules", component: <ModulesList /> },
  { path: "/modules/add", component: <AddModule /> },
  { path: "/modules/edit/:id", component: <EditModule /> },
  { path: "/screens", component: <ScreensList /> },
  { path: "/screens/add", component: <AddScreen /> },
  { path: "/screens/edit/:id", component: <EditScreen /> },
  { path: "/sections", component: <SectionsList /> },
  { path: "/sections/add", component: <AddSection /> },
  { path: "/sections/edit/:id", component: <EditSection /> },
  { path: "/sections/remove/:id", component: <RemoveSection /> },

  //Drivers
  { path: "/drivers", component: <DriversList /> },
  { path: "/drivers/add", component: <AddDriver /> },
  { path: "/drivers/add-document", component: <AddDriverDocument /> },
  { path: "/drivers/edit/:id", component: <EditDriver /> },
  { path: "/drivers/control/:id", component: <ControlDriver /> },
  { path: "/drivers/trreport", component: <DriverTrReport /> },
  { path: "/drivers/remove/:id", component: <RemoveDriver /> },

  //Driver Types
  { path: "/driver-type", component: <DriverTypesList /> },
  { path: "/driver-type/add", component: <AddDriverType /> },
  { path: "/driver-type/edit/:id", component: <EditDriverType /> },
  { path: "/driver-type/remove/:id", component: <RemoveDriverType /> },

  //Collectors
  { path: "/collectors", component: <CollectorsList /> },
  { path: "/collectors/add", component: <AddCollector /> },
  { path: "/collectors/transfer-driver-wallet", component: <TransferDriverBalance /> },
  { path: "/collectors/clear-wallet", component: <ClearWallet /> },
  { path: "/collectors/edit/:id", component: <AddCollector /> },
  { path: "/collectors/remove/:id", component: <RemoveCollector /> },

  //Partners
  { path: "/partners", component: <PartnersList /> },
  { path: "/partners/add", component: <AddPartner /> },
  { path: "/partners/edit/:id", component: <EditPartner /> },
  { path: "/partners/remove/:id", component: <RemovePartner /> },

  //Partners Branch
  { path: "/partnersbranch", component: <PartnersBranchList /> },
  { path: "/partnersbranch/add", component: <AddPartnerBranch /> },
  { path: "/partnersbranch/edit/:id", component: <EditPartnerBranch /> },
  { path: "/partnersbranch/remove/:id", component: <RemovePartnerBranch /> },

  //Logs
  // { path: "/direct-delivery-logs", component: <DirectDeliveryLogs /> },
  { path: "/collection-hub-logs", component: <CollectionHubLogs /> },
  { path: "/order-logs", component: <OrderLogs /> },
  { path: "driver-logs", component: <DriverLogs /> },
  { path: "partner-logs", component: <PartnerLogs /> },
  { path: "partner-branch-logs", component: <PartnerBranchLogs /> },
  { path: "/sms-logs", component: <SmsLogs /> },

  //Partners Branch TimeSlot
  {
    path: "/partnersbranch/timeslot",
    component: <PartnersBranchTimeSlotList />,
  },
  {
    path: "/partnersbranch/timeslot/add",
    component: <AddPartnerBranchTimeSlot />,
  },
  {
    path: "/partnersbranch/timeslot/edit/:id",
    component: <EditPartnerBranchTimeSlot />,
  },
  {
    path: "/partnersbranch/timeslot/remove/:id",
    component: <RemovePartnerBranchTimeSlot />,
  },

  //Items
  { path: "/items", component: <ItemsList /> },
  { path: "/items/add", component: <AddItem /> },
  { path: "/items/edit/:id", component: <EditItem /> },
  { path: "/items/remove/:id", component: <RemoveItem /> },

  //Services
  { path: "/services", component: <ServicesList /> },
  { path: "/services/add", component: <AddService /> },
  { path: "/services/edit/:id", component: <EditService /> },
  { path: "/services/remove/:id", component: <RemoveService /> },

  //Shipment Types
  { path: "/shipment-types", component: <ShipmentTypeList /> },
  { path: "/shipment-types/add", component: <AddShipmentType /> },
  { path: "/shipment-types/edit/:id", component: <EditShipmentType /> },
  { path: "/shipment-types/remove/:id", component: <RemoveShipmentType /> },

  //Orders
  { path: "/orders", component: <OrdersList /> },
  { path: "/orders/add", component: <AddOrder /> },
  { path: "/orders/edit/:id", component: <EditOrder /> },
  { path: "/orders/view/:id", component: <OrderDetails /> },
  { path: "/orders/remove/:id/:type", component: <RemoveOrder /> },
  { path: "/orders/mod-order/:id/:type", component: <ModOrder /> },

  //Time slots
  { path: "/timeslots", component: <TimeslotList /> },
  { path: "/timeslots/add", component: <AddTimeSlot /> },
  { path: "/timeslots/edit/:id", component: <EditTimeSlot /> },
  { path: "/timeslots/remove/:id", component: <RemoveTimeSlot /> },
  { path: "/timeslots/exceptions", component: <TimeSlotExceptionList /> },
  { path: "/timeslots/exceptions/add", component: <AddTimeSlotException /> },
  {
    path: "/timeslots/exceptions/edit/:id",
    component: <EditTimeSlotException />,
  },
  {
    path: "/timeslots/exceptions/remove/:id",
    component: <RemoveTimeSlotException />,
  },

  //Status
  { path: "/status", component: <StatusList /> },
  { path: "/status/add", component: <AddStatus /> },
  { path: "/status/edit/:id", component: <EditStatus /> },
  { path: "/status/remove/:id", component: <RemoveStatus /> },

  //CollectionHubs
  { path: "/collhub", component: <CollHubList /> },
  { path: "/collhub/add", component: <AddCollHub /> },
  { path: "/collhub/edit/:id", component: <AddCollHub /> },
  { path: "/collhub/remove/:id", component: <RemoveCollHub /> },

  // payment methods
  { path: "/payment-methods", component: <PaymentMethodList /> },
  { path: "/payment-methods/add", component: <AddPaymentMethod /> },
  { path: "/payment-methods/edit/:id", component: <EditPaymentMethod /> },
  { path: "/payment-methods/remove/:id", component: <RemovePaymentMethod /> },

  // payment statuses
  { path: "/payment-statuses", component: <PaymentStatusesList /> },
  { path: "/payment-statuses/add", component: <AddPaymentStatus /> },
  { path: "/payment-statuses/edit/:id", component: <EditPaymentStatus /> },
  { path: "/payment-statuses/remove/:id", component: <RemovePaymentStatus /> },

  // emergency Sub types
  { path: "/emergency-sub-types", component: <EmergencySubTypesList /> },
  { path: "/emergency-sub-types/add", component: <AddEmergencySubType /> },
  {
    path: "/emergency-sub-types/edit/:id",
    component: <EditEmergencySubType />,
  },
  {
    path: "/emergency-sub-types/remove/:id",
    component: <RemoveEmergencySubType />,
  },

  // emergency types
  { path: "/emergency-types", component: <EmergencyTypesList /> },
  { path: "/emergency-types/add", component: <AddEmergencyType /> },
  { path: "/emergency-types/edit/:id", component: <EditEmergencyType /> },
  { path: "/emergency-types/remove/:id", component: <RemoveEmergencyType /> },

  // driver emergencies
  { path: "/driver-emergencies", component: <DriverEmergenciesList /> },
  { path: "/driver-emergencies/edit/:id", component: <EditDriverEmergency /> },
  // {
  //   path: "/driver-emergencies/remove/:id",
  //   component: <RemoveDriverEmergency />,
  // },

  // articles
  { path: "/articles", component: <ArticlesList /> },
  { path: "/articles/add", component: <AddArticle /> },
  { path: "/articles/edit/:id", component: <EditArticle /> },
  { path: "/articles/remove/:id", component: <RemoveArticle /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  // { path: "/forgot-password", component: <ForgetPwd /> },
  // { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
